<template>
<div>
  <form action="/">
    <van-search v-model="value" show-action placeholder="请输入搜索关键词" @search="onSearch">
      <template slot="action">
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
  </form>
  <div>
    <van-cell v-for="item in cheguaItems" :key="item.id" :title="item.cheguahao" @click="chooseChegua" />
  </div>
</div>
</template>

<script>
import {
  Toast
} from 'vant';
import api from '@/fetch/api';

export default {
  created: function() {
    document.title = "搜索车挂信息";
  },
  data() {
    return {
      value: '',
      cheguaItems: [],
    };
  },
  methods: {
    chooseChegua(e) {
      var cheguahao = e.currentTarget.innerText;
      if (cheguahao.length > 0) {
        sessionStorage.setItem('cheguahao', cheguahao);
        this.$router.push({
          name: 'addAllCar'
        });
      }
    },
    onSearch() {
      var that = this;
      var search = that.value;
      if (search.length == 0) {
        Toast('查询的内容不能为空');
      } else {
        api.searchChegua(search).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.$set(that.$data, 'cheguaItems', res.data);
          }
        }).catch(function(err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        });
      }
    },
    onCancel() {
      Toast('取消');
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
